type locationDataEntry = {
  name: string;
  postcode: string;
  distance: number;
  cityIntro?: string;
  avgPriceCents?: number;
};

const locationData: { [key: string]: locationDataEntry } = {
  amsterdam: {
    name: 'Amsterdam',
    postcode: '1012EG',
    distance: 10000,
    avgPriceCents: 2669502,
    cityIntro:
      'Geef mij maar Amsterdam, én een compacte stadsauto die makkelijk door de drukke straten beweegt. Of juist een comfortabele auto waarmee je zo de ring op rijdt.',
  },
  rotterdam: {
    name: 'Rotterdam',
    postcode: '3032AC',
    distance: 7000,
    avgPriceCents: 2162981,
    cityIntro:
      'In Rotterdam is het wel zo fijn als je auto overal voor in is. Van een wendbare auto voor in de stad tot een ruime gezinsauto voor alles daarbuiten.',
  },
  'den+haag': {
    name: 'Den Haag',
    postcode: '2511DE',
    distance: 4000,
    avgPriceCents: 1697976,
    cityIntro:
      'Van een ritje naar het strand tot dagelijks de stad in: in Den Haag komt een fijne auto goed van pas. Klein en wendbaar of juist lekker ruim, er is altijd een auto die bij je past.',
  },
  utrecht: {
    name: 'Utrecht',
    postcode: '3512JE',
    distance: 4000,
    avgPriceCents: 1004187,
    cityIntro:
      'In Utrecht is een kleine, zuinige auto soms wel zo handig in de drukke stad. Liever wat meer ruimte voor boodschappen, kinderen of weekendjes weg? Ook dan is er genoeg te kiezen.',
  },
  eindhoven: {
    name: 'Eindhoven',
    postcode: '5611EB',
    distance: 4000,
    avgPriceCents: 2230033,
    cityIntro:
      'Vanuit Eindhoven de Brabantse dorpen in of juist kilometers maken voor werk: met een fijne auto kun je alle kanten op. Elektrisch, sportief of gewoon lekker praktisch, hier kun je het zo gek maken als je zelf wil.',
  },
  almere: {
    name: 'Almere',
    postcode: '1315VJ',
    distance: 6000,
    avgPriceCents: 2467904,
    cityIntro:
      'Almere is ruim opgezet, dus een auto komt er goed van pas. Misschien zoek je een praktische gezinsauto met lekker veel ruimte, of juist iets zuinigs voor je dagelijkse ritten.',
  },
  groningen: {
    name: 'Groningen',
    postcode: '9712HS',
    distance: 5000,
    avgPriceCents: 3274853,
    cityIntro:
      'Er gaat niets boven Groningen. Zeker als je vanuit de stad ook graag de Ommelanden ontdekt. Dus zoek je een fijne auto voor elke dag, of eentje waarmee je graag wat extra kilometers maakt?',
  },
  tilburg: {
    name: 'Tilburg',
    postcode: '5048AB',
    distance: 4000,
    avgPriceCents: 2334498,
    cityIntro:
      'Of je nu door Tilburg rijdt of regelmatig de Brabantse wegen op gaat, een fijne auto maakt het nét wat makkelijker. Van compact en zuinig tot ruim en comfortabel.',
  },
  nijmegen: {
    name: 'Nijmegen',
    postcode: '6511KA',
    distance: 4000,
    avgPriceCents: 1249815,
    cityIntro:
      'In en rond Nijmegen valt genoeg te ontdekken, van de levendige stad tot de groene en heuvelachtige omgeving. Dan is het fijn om een auto te vinden die past bij jouw dagelijkse ritten én plannen daarbuiten.',
  },
  arnhem: {
    name: 'Arnhem',
    postcode: '6811AD',
    distance: 6000,
    avgPriceCents: 3114419,
    cityIntro:
      'Van de Arnhemse binnenstad tot de Veluwe: met de auto ligt er een hoop binnen bereik. Of je nu iets compacts zoekt of juist ruimte en comfort wilt.',
  },
  haarlem: {
    name: 'Haarlem',
    postcode: '2011MJ',
    distance: 4000,
    avgPriceCents: 1785751,
    cityIntro:
      'In Haarlem is een compacte auto handig in de stad, terwijl je met een comfortabele auto zo richting strand of Amsterdam rijdt. Voor iedere rit is wel iets te vinden.',
  },
  amersfoort: {
    name: 'Amersfoort',
    postcode: '3811CK',
    distance: 5000,
    avgPriceCents: 1636724,
    cityIntro:
      'Amersfoort ligt lekker centraal, dus met de auto kun je alle kanten op. Van dagelijkse ritjes in en rond de stad tot een dagje richting de Utrechtse Heuvelrug of de Veluwe.',
  },
  breda: {
    name: 'Breda',
    postcode: '4811XS',
    distance: 4000,
    avgPriceCents: 2334444,
    cityIntro:
      'Van de Bredase binnenstad tot een rit richting Antwerpen: met een fijne auto ben je zo onderweg. Compact, ruim, sportief of comfortabel, er valt genoeg te kiezen.',
  },
  apeldoorn: {
    name: 'Apeldoorn',
    postcode: '7339GM',
    distance: 4000,
    avgPriceCents: 2913966,
    cityIntro:
      'In Apeldoorn heb je de Veluwe praktisch om de hoek. Misschien zoek je een betrouwbare auto voor elke dag, of eentje waar je met het hele gezin en alle spullen makkelijk mee op pad gaat.',
  },
  enschede: {
    name: 'Enschede',
    postcode: '7511GD',
    distance: 5000,
    avgPriceCents: 1647713,
    cityIntro:
      'Van het centrum van Enschede tot een ritje over de grens: met de auto ben je zo onderweg. Misschien zoek je iets kleins en zuinigs, of juist een comfortabele auto voor meer kilometers.',
  },
  zwolle: {
    name: 'Zwolle',
    postcode: '8011CT',
    distance: 5000,
    avgPriceCents: 2341068,
    cityIntro:
      'Zwolle is een mooie uitvalsbasis voor ritten door de stad én de regio. Of je nu iets wendbaars zoekt of een auto waarmee je comfortabel kilometers maakt.',
  },
  leiden: {
    name: 'Leiden',
    postcode: '2312JA',
    distance: 3000,
    avgPriceCents: 1903976,
    cityIntro:
      'Met de smalle straten van Leiden is een compacte auto soms wel zo makkelijk. Maar voor ritten richting kust, Den Haag of Amsterdam mag het natuurlijk ook wat ruimer en comfortabeler.',
  },
  zoetermeer: {
    name: 'Zoetermeer',
    postcode: '2711BP',
    distance: 3000,
    avgPriceCents: 1751331,
    cityIntro:
      'Van Zoetermeer naar Den Haag, Rotterdam of gewoon de andere kant van de stad: met de auto zijn er genoeg kanten om op te gaan. Dan is het fijn als je er eentje vindt die bij jouw ritten past.',
  },
  maastricht: {
    name: 'Maastricht',
    postcode: '6211CL',
    distance: 4000,
    avgPriceCents: 2963556,
    cityIntro:
      'In Maastricht rijd je zo van de historische binnenstad het Limburgse heuvelland in. En met België om de hoek liggen ook langere ritten voor de hand.',
  },
  dordrecht: {
    name: 'Dordrecht',
    postcode: '3312KW',
    distance: 3000,
    avgPriceCents: 2535139,
    cityIntro:
      'Van de historische binnenstad van Dordrecht tot de wegen richting Rotterdam en Brabant: een fijne auto brengt je zo op weg. Klein en praktisch of juist ruim en comfortabel.',
  },
};

export default locationData;
